import { useEffect, useState } from "react";
import moment from "moment";
import ModalDialog from "../component/Modal";
import { useTranslation } from "react-i18next";
import ActionButton from "../component/ActionButton";
import { LocalStorage } from "../util/Utils";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { CommonService } from "../store/common/CommonSlice";
import { useDispatch } from "react-redux";

interface idealTimeoutProps {
  onActive(): void;
  onIdle(): void;
  timeOutInterval: number;
  onLogout(): void;
}
const IdleTimeOutHandler = (props: idealTimeoutProps) => {
   const dispatch = useDispatch<any>();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [isLogout, setLogout] = useState(false);
  let timer: any = undefined;
  const events = ["click", "scroll", "load", "keydown"];
  const eventHandler = () => {
    if (!isLogout) {
      LocalStorage.append("lastInteractionTime", new Date().toString());
      if (timer) {
        props.onActive();
        startTimer();
      }
    }
  };

  useEffect(() => {
    addEvents();

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  });

  window.addEventListener("storage", (event: any) => {
    if (LocalStorage.get("unauthorized")) setShowModal(true);
  });

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(
      () => {
        let lastInteractionTime = LocalStorage.get("lastInteractionTime");
        const diff = moment.duration(
          moment().diff(moment(lastInteractionTime))
        );
        let timeOutInterval = props.timeOutInterval
          ? props.timeOutInterval
          : 6000;
        if (isLogout) {
          clearTimeout(timer);
        } else {
          if (diff.asMilliseconds() < timeOutInterval) {
            startTimer();
            props.onActive();
          } else {
            props.onIdle();
            setShowModal(true);
          }
        }
      },
      props.timeOutInterval ? props.timeOutInterval : 6000
    );
  };
  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });

    startTimer();
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  const handleLogout = () => {
    removeEvents();
    clearTimeout(timer);
    setLogout(true);
    logoutAPICall();
    props.onLogout();
    setShowModal(false);
  };

  const logoutAPICall = () => {
      dispatch(
        CommonService({
          apiAction: "logout",
          common: {
            requestData: LocalStorage.get("user-token"),
          },
        })
      )
        .then((result: any) => {
          if (result?.payload?.status === 200) {
            LocalStorage.remove(undefined, true);
            window.location.href =
              window.location.origin + window.location.pathname;
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    };
  

  return (
    <div>
      <ModalDialog
        state={showModal}
        title={t("login.sessionTimeout")}
        onClose={""}
        size="s"
        closeButtonHide={true}
        content={
          <div>
            <div className="flex session-timeout-body">
              <div className="flex center margin-right-5">
                <ReportProblemIcon style={{ color: "red" }} />
              </div>
              <div className="font-14 margin-y-10 flex center">
                {t("login.sessionExpired")}
              </div>
            </div>
            <div className="border-top padding-up-15 padding-down-10 center-end flex-gap bottom-btn center-end">
              <ActionButton
                onClick={handleLogout}
                label={t("logout")}
              ></ActionButton>
            </div>
          </div>
        }
      ></ModalDialog>
    </div>
  );
};

export default IdleTimeOutHandler;
